import { useEffect, useRef } from 'react';

const useCountUp = (target: number, durationMs: number) => {
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    let frame = 0;
    let lastValue = 0;
    const start = performance.now();
    const tick = (now: number) => {
      const progress = Math.min((now - start) / durationMs, 1);
      const value = Math.round(target * progress);
      if (ref.current && value !== lastValue) {
        ref.current.textContent = String(value);
        lastValue = value;
      }
      if (progress < 1) {
        frame = requestAnimationFrame(tick);
      }
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [target, durationMs]);

  return ref;
};
export default useCountUp;
